import { compactArray } from '../../../utils/utils'

const WINDOW_WIDTH = 408
const WINDOW_OFFSET = 10

export function isOpened (windows, id) {
  return Boolean(windows[id])
}

export function getWindowPosition (windows, hasMarkets) {
  let width = hasMarkets ? WINDOW_WIDTH + 600 : WINDOW_WIDTH
  const height = window.screen.availHeight

  const windowsArray = compactArray(Object.values({ ...windows })).filter(item => item)
  const max = window.screen.availWidth
  let left = 0

  windowsArray.forEach(item => {
    left += item.hasMarkets ? WINDOW_WIDTH + 600 + WINDOW_OFFSET : WINDOW_WIDTH + WINDOW_OFFSET

    if (left > max) {
      left = 0
    }
  })

  return {
    width,
    height,
    left
  }
}
